/*  ========================================================================
    # Scripts - ImageSlider
    ========================================================================  */

const ImageSlider = {
  cfg: {
    imageSliderWrappers: document.querySelectorAll('.s-image-slider__wrapper')
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.imageSliderWrappers.forEach(wrapper => {
      const controlLeft = wrapper.querySelector('.s-image-slider__control-left');
      const controlRight = wrapper.querySelector('.s-image-slider__control-right');
      const entries = wrapper.querySelector('.s-image-slider__entries');

      controlLeft.addEventListener('click', () => {
        entries.scrollBy(-50, 0);
      });

      controlRight.addEventListener('click', () => {
        entries.scrollBy(50, 0);
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.imageSliderWrappers.length > 0) this.handler();
  }
};

export default ImageSlider;
